<template>
  <div class="signin-wrapper2">
    <div class="register-modal-left">
      <img
        src="../img/eflexLogo.png"
        class="registration-icon"
        alt="eflex icon"
      />
      <p class="registration-description">
        Welcome back! We love to have you back
      </p>
      <p></p>
    </div>
    <div class="register-modal-right">
      <form
        name="form"
        @submit.prevent="handleRegister"
        v-if="!email && !code && !password"
      >
        <div v-if="!successful">
          <h4 class="registration-header">Login</h4>
          <div class="registration-subheader">
            Don't have an account yet?
            <a class="registration-link" href="/register">Register</a>
          </div>
          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="email">Email</label>
                <input
                  v-model="user.email"
                  v-validate="'required'"
                  type="text"
                  class="bottom-margin2"
                  name="email"
                  placeholder="Enter your email."
                />
                <div
                  v-if="errors.has('email')"
                  class="alert alert-danger"
                  role="alert"
                >
                  <font color="red">Email is required!</font>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-flex">
              <div class="column2">
                <label for="password">Password</label>
                <input
                  v-model="user.password"
                  v-validate="'required'"
                  type="password"
                  class="bottom-margin2"
                  name="password"
                  placeholder="Enter your password."
                />
                <div
                  v-if="errors.has('password')"
                  class="alert alert-danger"
                  role="alert"
                >
                  <font color="red">Password is required!</font>
                </div>
              </div>
            </div>
          </div>
          <div class="signin-modal-bottom">
            <v-btn
              elevation="2"
              color="#59c26b"
              class="signin-modal-bottom"
              v-on:click="handleLogin"
              :loading="loading"
              :disabled="loading || !user.email || !user.password"
            >
              Login</v-btn
            >
            <div class="forget-password" v-on:click="forgetPassword">
              Forgot password
            </div>
          </div>
        </div>
        <div class="form-group">
          <div
            v-if="message"
            class="alert"
            :class="successful ? 'alert-success' : 'alert-danger'"
          >
            {{ message }}
          </div>
        </div>
      </form>
      <div v-if="email && !code && !password">
        <h4 class="registration-header">
          Please submit your email to reset your password
        </h4>
        <div class="registration-subheader">
          Once we verify your email, we will send you a 5 digit pin number.
        </div>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="email">Email</label>
              <input
                v-model="user.email"
                v-validate="'required'"
                type="text"
                class="bottom-margin2"
                name="email"
                placeholder="Enter your email."
              />
              <div
                v-if="errors.has('email')"
                class="alert alert-danger"
                role="alert"
              >
                <font color="red">Email is required!</font>
              </div>
            </div>
          </div>
          <div class="signin-modal-bottom">
            <v-btn
              elevation="2"
              color="#59c26b"
              class="signin-modal-bottom"
              :loading="loading"
              :disabled="loading || !user.email"
              v-on:click="submitEmail"
            >
              Submit</v-btn
            >
          </div>
        </div>
      </div>
      <div v-if="!email && code && !password">
        <h4 class="registration-header">
          Please enter your 5 digit verification code:
        </h4>
        <div class="registration-subheader">
          You will find this code in at the emaill address you provided
        </div>
        <CodeInput
          :loading="false"
          class="input"
          v-on:complete="onComplete"
          :fields="5"
        />
        <div v-if="pinError" class="pin-error">Invalid pin</div>
        <div class="signin-modal-bottom">
          <v-btn
            elevation="2"
            color="#59c26b"
            class="signin-modal-bottom"
            :loading="loading"
            :disabled="loading || codeDigits.length < 5"
            v-on:click="submitCode"
          >
            Submit</v-btn
          >
        </div>
      </div>
      <div v-if="!email && !code && password">
        <h4 class="registration-header">Please enter your new password</h4>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="password">Password</label>
              <input
                v-model="newPassword"
                v-validate="'required'"
                type="password"
                class="bottom-margin2"
                name="password"
              />
              <div
                v-if="errors.has('password')"
                class="alert alert-danger"
                role="alert"
              >
                <font color="red">Password is required!</font>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="password">Confirm Password</label>
              <input
                v-model="newPasswordConfirm"
                v-validate="'required'"
                type="password"
                class="bottom-margin2"
                name="password"
              />
              <div
                v-if="errors.has('password')"
                class="alert alert-danger"
                role="alert"
              >
                <font color="red">Confirm password is required!</font>
              </div>
            </div>
          </div>
        </div>
        <div class="signin-modal-bottom">
          <v-btn
            elevation="2"
            color="#59c26b"
            class="signin-modal-bottom"
            :loading="loading"
            :disabled="loading || !newPassword || !newPasswordConfirm"
            v-on:click="submitPassword"
          >
            Submit</v-btn
          >
        </div>
      </div>
      <v-dialog v-model="confirm" persistent max-width="500">
        <v-card>
          <v-card-title class="text-h5">
            Password reset successfull
          </v-card-title>
          <v-card-text>Please login again with your new password.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="confirmSwitch">
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import User from "../models/user";
import CodeInput from "vue-verification-code-input";
import axios from "axios";

export default {
  name: "Login",
  components: {
    CodeInput,
  },
  data() {
    return {
      user: new User("", ""),
      newPassword: "",
      newPasswordConfirm: "",
      codeDigits: "",
      loading: false,
      email: false,
      pinError: false,
      code: false,
      password: false,
      confirm: false,
      message: "",
    };
  },

  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    onComplete(code) {
      this.codeDigits = code;
    },
    forgetPassword() {
      this.email = true;
    },
    submitEmail() {
      this.loading = true;
      axios
        .post("http://eflex-dev.azurewebsites.net/api/auth/forgot-password", {
          email: this.user.email,
        })
        .then(
          (response) => {
            this.loading = false;
            this.email = false;
            this.code = true;
          },
          (error) => {
            this.loading = false;
            console.log(error.response);
          }
        );
    },
    submitCode() {
      this.loading = true;
      this.pinError = false;
      axios
        .post("http://eflex-dev.azurewebsites.net/api/auth/reset-password", {
          otp: Number(this.codeDigits),
          email: this.user.email,
        })
        .then(
          (response) => {
            this.loading = false;
            this.code = false;
            this.password = true;
          },
          (error) => {
            this.loading = false;
            this.pinError = true;
            console.log(error.response);
          }
        );
    },
    submitPassword() {
      this.loading = true;
      axios
        .post("http://eflex-dev.azurewebsites.net/api/auth/change-password", {
          email: this.user.email,
          password: this.newPassword,
        })
        .then(
          (response) => {
            this.loading = false;
            this.confirm = true;
          },
          (error) => {
            this.loading = false;
            console.log(error);
          }
        );
    },
    confirmSwitch() {
      this.confirm = false;
      this.password = false;
      this.$router.push("/login");
    },
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.email && this.user.password) {
          console.log("working")
          this.$store.dispatch("auth/login", this.user).then(
            () => {
              //this.$router.push('/profile');
              console.log("HEREyou go", this.currentUser.roles[0].name)
              switch (this.currentUser.roles[0].name) {
                case "ROLE_ADMIN":
                  this.$router.push("/dashboardAdmin");

                  break;
                // case "ROLE_MOD":
                //   this.$router.push("/dashboardMod");

                //   break;

                case "ROLE_TSO":
                  this.$router.push("/dashboardTSO");

                  break;
                case "ROLE_DSO":
                  this.$router.push("/dashboardDSO");

                  break;
                case "ROLE_FSP":
                  this.$router.push("/dashboardFSP");

                  break;
                default:
                  this.$router.push("/dashboardDSO");
              }
            },
            (error) => {
              this.loading = false;
              console.log("DFADFSADFASDF", error.response.status)
              if (error.response.status == 401) {
                this.message = "Invalid email or password"
              } else {
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              }
            }
          );
        }
      });
    },
  },
};
</script>

<!-- 
<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style> 
-->

<style lang="scss">
@import "../sass/main.scss";

.signin-wrapper2 {
  width: 100%;
  min-height: 100vh;
  background: $green-background;
  margin-top: -100px;
  display: flex;
}

.register-modal {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 1px 4px 0 hsla(0, 0%, 0%, 0.2);
  display: flex;
}

.register-modal-left {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #253858;
  padding: 20px;
  width: 35%;
  overflow-x: hidden;
  background-image: url(../img/regImage.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.registration-icon {
  width: 150px;
  margin-bottom: 20px;
}

.registration-description {
  align-self: flex-start;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  width: 70%;
  margin-top: 50px;
}

.register-modal-left h4 {
  margin: 0 0 40px 0;
}

.registration-city {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: contain;
  opacity: 0.4;
}

.already-wrapper {
  margin-left: 10px;
}

.register-modal-right {
  padding: 100px 40px 40px 40px;
  width: 65%;
  background-color: #f8fcff;
}

.register-modal-right label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
  color: #979797;
}

.register-modal-right input,
.register-modal-right select {
  width: 100%;
  padding: 12px 10px !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #fff;
}

.register-modal-right input:focus,
.register-modal-right select:focus {
  outline: none;
  border: 1px solid #6680a0;
  box-shadow: 0 0 5px #c8d2da;
}

.register-modal-right a {
  margin-top: 5px;
  margin-left: 5px;
  font-size: 0.75em;
  display: inline-block;
}

.register-modal-left .already-wrapper {
  font-size: 0.85em;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.register-modal .bottom-margin {
  margin-bottom: 10px;
}

.bottom-margin2 {
  margin-bottom: 20px;
}

.column2 {
  width: 48%;
}

.VueCarousel-slide > div {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
}

.registration-header {
  font-size: 24px;
  margin-bottom: 20px;
}

.registration-subheader {
  font-size: 18px;
  margin-bottom: 20px;
}

.registration-link {
  font-size: 18px !important;
  color: #59c26b !important;
  text-decoration: underline;
  font-weight: 700;
}

.register-modal-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  padding: 0 10px;
}

.cancel-button {
  width: 100%;
  color: $black !important;
  background: $dark-white !important;
  padding: 10px 15px;
  border-radius: 10px;
  border: none;
  background: $green;
  color: #fff;
}

.cancel-button:hover {
  background: hsl(210, 23%, 97%) !important;
}

.next-button {
  background: rgba(0, 0, 0, 0) !important;
  color: $black !important;
  border: 2px solid $green2 !important;
}

.next-button:hover {
  border: 2px solid hsl(144, 58%, 40%) !important;
}

.register-modal-button-wrapper a {
  border-radius: 10px;
  border: none;
  background: $green2;
  color: #fff;
}

.register-modal-button-wrapper a:hover {
  color: $black;
  text-decoration: none;
}

.register-modal-button-wrapper > button {
  width: 45%;
  padding: 10px 15px;
  border-radius: 10px;
  border: none;
  background: $green;
  color: #fff;
}

.register-modal-button-wrapper > button:hover {
  background: hsl(144, 58%, 40%);
}

.register-modal-button-wrapper button:focus {
  outline: none;
}

.checkbox-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 20px 5px;
  flex: 1;
}

.checkbox {
  width: auto !important;
}

.checkbox-label {
  margin: 0 0 0 10px !important;
}

.loader {
  background: rgba(0, 0, 0, 0.4);
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.loader .helper {
  display: none;
  height: 40%;
  vertical-align: middle;
}
.loader > div {
  background-color: #fff;
  box-shadow: 10px 10px 60px #555;
  display: none;
  width: 20%;
  position: fixed;
  border-radius: 8px;
  padding: 15px 5%;
  margin-top: 19%;
  margin-left: -10%;
}

.link:hover {
  text-decoration: underline;
}

.signin-modal-bottom {
  width: 30%;
  margin-top: 20px;
}

.signin-modal-bottom span {
  color: #fff;
  text-transform: none;
}

.forget-password {
  font-size: 14px !important;
  color: #59c26b !important;
  text-decoration: underline;
  font-weight: 400;
  margin-top: 5px;
  cursor: pointer;
}

.input {
  width: 100% !important;
}

.input input {
  margin: 10px 5px 20px 5px;
  border-radius: 3px !important;
  border: 1px solid #dbdbdb !important;
  font-family: "Roboto" !important;
}

.pinError {
  color: #a41517;
}
</style>
